import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import rolesAdmin from '../../../../apis/admin/rolesService';

type RoleListState = {
    roles: []
    isLoading: boolean
}

const initialState: RoleListState = {
    roles: [],
    isLoading: false,
};

export const getRoleDatas = createAsyncThunk(
    'role/ListRoleState',
    async () => {
        const response: any = await rolesAdmin.getRolesData();
        return response?.data?.data?.payload
    }
)
export const roleSlice = createSlice({
    name: 'Roleslist',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getRoleDatas.pending, (state) => {
                state.isLoading = false
                state.roles = []
            })
            .addCase(getRoleDatas.fulfilled, (state, action: any) => {
                state.isLoading = true
                state.roles = action.payload
            })
            .addCase(getRoleDatas.rejected, (state, action) => {
                state.isLoading = true
                state.roles = []
            });
    },
});

export default roleSlice.reducer;